module.exports = __webpack_public_path__ + "images/about@3x.png?f4fd4c7a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about@3x.png
// module id = 593
// module chunks = 7